import { ClipboardList } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { PageHeader } from "../components/ui/PageHeader";
import { PanelTour } from "../components/ui/PanelTour";
import { FormsList } from "../features/forms/FormsList";
import { formPermissions } from "../features/forms/permissions";
export function FormsView() {
  const { identity, isLoading } = useAuth();
  const perms = formPermissions(identity, import.meta.env.DEV);
  useDocumentTitle("Forms");
  if (!perms.read) return <p>You do not have access to Forms.</p>;
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Community"
        title="Forms"
        icon={ClipboardList}
        description="Good questions. Useful answers. All in one place."
        actions={
          <PanelTour
            tourId="forms-library"
            title="Forms"
            enabled={!isLoading}
            onStart={() => {}}
            onEnd={() => {}}
            onNavigate={() => {}}
            steps={[
              {
                id: "start",
                title: "Start with the work, not a blank page",
                description:
                  "Choose a template or start fresh. Every form is independent; event feedback is one useful option.",
                target: perms.write
                  ? '[data-tour="forms-start"]'
                  : '[data-tour="forms-library"]',
              },
              {
                id: "library",
                title: "Keep the whole conversation together",
                description:
                  "Open a form to write questions, choose optional rewards, preview, publish, manage short links, and explore responses. Every editor has a full guided tour. Duplicate a form to reuse it, or use Delete draft to remove an unpublished draft.",
                target: '[data-tour="forms-library"]',
              },
            ]}
          />
        }
      />
      <FormsList canWrite={perms.write} />
    </div>
  );
}
